import { EventsBySportIdRequest } from "../../dependencies";
/**
 * Get market event id in FullBetSlip format
 * @param {Event} e Event, from which to retrieve id
 * @param {Market} m Market, from which to retrieve id
 * @return {string} Market event id
 */
// TODO: DayOfEventRace needs to be added in EventTypesEnum contract: https://jira.sbtech.com/browse/SB-188950
var eventTypesEnum = [EventsBySportIdRequest.EventTypesEnum.Outright.toString(), EventsBySportIdRequest.EventTypesEnum.AntePostRace.toString(), "DayOfEventRace"];
export var getMarketEventID = function (e, m) {
    return e.type && eventTypesEnum.includes(e.type)
        ? "0"
        : m.eventId || "0";
};
//# sourceMappingURL=getMarketEventID.js.map